// src/pages/manager/ManagerOverviewPage.js
import React, { useState, useEffect } from 'react';
import { auth, db } from '../../firebase';
import { collection, getDocs, query, where } from 'firebase/firestore';
import MetricsDashboard from '../admin/MetricsDashboard'; // Reutiliza do Admin
import CaixaDeEntrada from '../../CaixaDeEntrada'; // Reutiliza da raiz src/
import { Typography, CircularProgress, Box } from '@mui/material';

function ManagerOverviewPage() {
    const user = auth.currentUser;
    const [parceiros, setParceiros] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchParceiros = async () => {
            if (!user) return;
            const q = query(collection(db, "usuarios"), where("gerenteId", "==", user.uid));
            const data = await getDocs(q);
            setParceiros(data.docs.map(doc => ({ ...doc.data(), id: doc.id })));
            setLoading(false);
        };
        fetchParceiros();
    }, [user]);

    if (loading) return <Box sx={{ display: 'flex', justify: 'center', p: 3 }}><CircularProgress /></Box>;

    return (
        <>
            <Typography variant="body1" sx={{ mb: 2 }}>Logado como: {user?.email}</Typography>
            
            <MetricsDashboard usuarios={parceiros} />
            
            <Box sx={{ mt: 4 }}>
                <CaixaDeEntrada user={user} />
            </Box>
        </>
    );
}

export default ManagerOverviewPage;